import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-center',
  templateUrl: './app-center.component.html',
  styleUrls: ['./app-center.component.scss']
})
export class AppCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
